import { gql } from '@apollo/client';
export const CONTENT_ITEM_FIELDS = gql `
  fragment ContentItemFields on ContentItem {
    id
    createdAt
    updatedAt
    clientId
    parentId
    code
    language
    value
    title
  }
`;
export const CONTENT_ITEMS = gql `
  ${CONTENT_ITEM_FIELDS}
  query CONTENT_ITEMS($spec: ContentItemSpec!) {
    contentItems(spec: $spec) {
      ...ContentItemFields
    }
  }
`;
export const USER_CONTENT_ITEMS = gql `
  ${CONTENT_ITEM_FIELDS}
  query USER_CONTENT_ITEMS($spec: UserContentItemSpec!) {
    userContentItems(spec: $spec) {
      ...ContentItemFields
    }
  }
`;
export const SAVE_CONTENT_ITEM = gql `
  ${CONTENT_ITEM_FIELDS}
  mutation SAVE_CONTENT_ITEM($input: ContentItemInput!) {
    saveContentItem(input: $input) {
      ...ContentItemFields
    }
  }
`;
export const DELETE_CONTENT_ITEM = gql `
  ${CONTENT_ITEM_FIELDS}
  mutation DELETE_CONTENT_ITEM($id: Int!) {
    deleteContentItem(id: $id) {
      ...ContentItemFields
    }
  }
`;
